import defaultPalette from '../palette';
export default (function (_a) {
    var _b, _c;
    var _d = _a.palette, palette = _d === void 0 ? defaultPalette : _d;
    return {
        MuiCheckbox: {
            indeterminate: {
                color: (_b = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _b === void 0 ? void 0 : _b.light,
            },
            colorPrimary: {
                '&$checked': {
                    color: (_c = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _c === void 0 ? void 0 : _c.light,
                },
                '&&$disabled': {
                    color: palette === null || palette === void 0 ? void 0 : palette.grey[400],
                    '&$checked': {
                        color: palette === null || palette === void 0 ? void 0 : palette.primary[100],
                    },
                    '&$indeterminate': {
                        color: palette === null || palette === void 0 ? void 0 : palette.primary[100],
                    },
                },
            },
        },
    };
});
